import { render, staticRenderFns } from "./Base3.vue?vue&type=template&id=6272a5a8&scoped=true&"
import script from "./Base3.vue?vue&type=script&lang=js&"
export * from "./Base3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6272a5a8",
  null
  
)

export default component.exports